import { render, staticRenderFns } from "./VPSFFOtpComponent.vue?vue&type=template&id=048146f9&scoped=true"
import script from "./VPSFFOtpComponent.vue?vue&type=script&lang=js"
export * from "./VPSFFOtpComponent.vue?vue&type=script&lang=js"
import style0 from "./VPSFFOtpComponent.vue?vue&type=style&index=0&id=048146f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048146f9",
  null
  
)

export default component.exports